import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=740d64a3&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Detail.vue?vue&type=style&index=1&id=740d64a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740d64a3",
  null
  
)

export default component.exports